import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgModule } from '@angular/core';
import { RxIconModule } from '../rx-icon/rx-icon.module';
import { RxSpinnerComponent } from './spinner/rx-spinner.component';
import { RxSpinnerDirective } from './rx-spinner.directive';

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    RxIconModule,
    RxSpinnerComponent,
    RxSpinnerDirective,
  ],
  exports: [RxSpinnerComponent, RxSpinnerDirective],
})
export class RxSpinnerModule {}
